import { render, staticRenderFns } from "./AltCardDataPopup.vue?vue&type=template&id=54c1801d&"
import script from "./AltCardDataPopup.vue?vue&type=script&lang=js&"
export * from "./AltCardDataPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports